import { LoginGateType } from 'common/events/ClientEvents';
import { createContext, useContext } from 'react';

/** Undefined outside LoginOrSignUpModal, so /login's events carry no gateType. */
export const GateTypeContext = createContext<LoginGateType | undefined>(undefined);

export const useGateType = () => useContext(GateTypeContext);
